var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 1072,
    viewBox: "0 0 145 1072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "The_Best_Free_Online",
    "data-name": "The Best Free Online",
    transform: "translate(0 1071) rotate(-90)",
    fill: "#e71e2c",
    fontSize: 119,
    fontFamily: "Montserrat-Light, Montserrat",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 115
  }, "JOBANZEIGEN"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobTitle);
export default __webpack_public_path__ + "static/media/job-title.df11c895.svg";
export { ForwardRef as ReactComponent };